/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato interno di una ricarica del servizio mensa.
 */
export enum ServizioMensaRicaricaStato {

    GENERAZIONE_IN_CORSO = 'GENERAZIONE_IN_CORSO',

    IN_ATTESA_PAGAMENTO = 'IN_ATTESA_PAGAMENTO',

    PAGATA = 'PAGATA',

    ERRORE = 'ERRORE',

    CANCELLATA = 'CANCELLATA'
}

